import { combineReducers } from 'redux';

import ServedItemSetup from './serveditemsetup/reducer';
import EditServedItem from './editserveditem/reducer';
import ColorSetup from './colorsetup/reducer';

export default combineReducers({
  ServedItemSetup,
  EditServedItem,
  ColorSetup,
});



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/state/reducer.js